import { usePrivateModeStore } from "@src/stores/usePrivateModeStore"
import { isOnSensitiveRoute } from "./sensitiveRoutes"

export { SENSITIVE_ROUTES, isOnSensitiveRoute } from "./sensitiveRoutes"

/**
 * Synchronous suppression check. Reads private-mode from both the zustand
 * store and raw localStorage (fallback for pre-hydration window).
 */
export function isAnalyticsSuppressed(): boolean {
  if (typeof window === "undefined") return true

  const { isPrivateModeEnabled } = usePrivateModeStore.getState()
  if (isPrivateModeEnabled) return true

  // Fallback: read localStorage directly in case persist middleware hasn't hydrated yet
  // SYNC: key and shape must match usePrivateModeStore persist config
  try {
    const raw = localStorage.getItem("app_private_mode")
    if (raw) {
      const parsed = JSON.parse(raw)
      if (parsed?.state?.isPrivateModeEnabled) return true
    }
  } catch {}

  return isOnSensitiveRoute(window.location.pathname)
}
